import { useFilters } from "@website/widget/filter";
import { useVillaFiltersSchema } from "./index.constant";

export const useVillagesFilter = (
  hotelListResultsCount: number,
  isListingDataFetched: boolean
) => {
  const { filtersSchema, chipsFiltersSchema, hasNearby } =
    useVillaFiltersSchema(isListingDataFetched);

  const { clearFilters } = useFilters({ schema: filtersSchema });

  return {
    hasNearby,
    clearAllFilters: clearFilters,
    filtersSchema,
    chipsFiltersSchema,
    hotelListResultsCount
  };
};
